<template>
  <div class="p-6 space-y-6">
    <div class="space-y-2">
      <label for="motorResponse" class="block text-sm font-medium text-gray-700"
        >Prefered Doctor</label
      >
      <select
        id="motorResponse"
        v-model="preferredDoctor"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
        required
      >
        <option class="text-gray-300" value="" disabled selected hidden>
          Select prefered doctor
        </option>
        <option value="dont_specify">Don't specify</option>
        <option
          v-for="(doctor, index) in doctors"
          :key="index"
          :value="doctor.UserId"
        >
          {{ doctor.Username }}
        </option>
      </select>
    </div>

    <div v-for="(field, index) in fields" :key="index" class="space-y-2">
      <label :for="field.id" class="block text-sm font-medium text-gray-700">
        {{ field.label }}
      </label>
      <div class="flex items-center space-x-4">
        <div class="flex-grow">
          <vue-multiselect
            v-if="field.type === 'multiselect'"
            v-model="field.value"
            :options="field.options"
            :multiple="true"
            :taggable="true"
            @tag="addTag(field.id, $event)"
            :placeholder="field.placeholder"
            :id="field.id"
            class="w-full"
          >
            <template #option="{ option }">
              <span class="option__desc">{{ option }}</span>
            </template>
            <template #tag="{ option, remove }">
              <span
                class="multiselect__tag bg-gray-200 text-gray-700 rounded-full px-2 py-1 mr-1"
              >
                <span>{{ option }}</span>
                <i class="multiselect__tag-icon" @click="remove(option)"></i>
              </span>
            </template>
          </vue-multiselect>
        </div>
        <button
          @click="setNone(field.id)"
          class="bg-blue-900 text-white px-4 py-2 rounded hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          None
        </button>
      </div>
    </div>

    <div class="space-y-2">
      <label
        for="triageNurseNotes"
        class="block text-sm font-medium text-gray-700"
      >
        Triage Nurse Notes
      </label>
      <textarea
        id="triageNurseNotes"
        v-model="triageNurseNotes"
        rows="5"
        class="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none focus:border-blue-500"
        placeholder="Type..."
      ></textarea>
    </div>

    <!-- <div class="flex justify-end space-x-4 mt-6">
        <button @click="cancel" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50">
          Cancel
        </button>
        <button @click="submit" class="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50">
          Submit
        </button>
      </div> -->
  </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";

export default {
  name: "ConsultationAdditionalInformationTab",
  components: {
    VueMultiselect,
  },
  props: {
    doctors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        // {
        //   id: "preferredDoctor",
        //   label: "Preferred Doctor",
        //   type: "multiselect",
        //   value: [],
        //   options: [],
        //   placeholder: "Type...",
        // },
        {
          id: "specialConsideration",
          label: "Special Consideration",
          type: "multiselect",
          value: [],
          options: ["Hearing Impairment"],
          placeholder: "Type...(Hearing Impairment)",
        },
      ],
      triageNurseNotes: "",
      preferredDoctor: "",
    };
  },
  methods: {
    addTag(fieldId, newTag) {
      const field = this.fields.find((f) => f.id === fieldId);
      field.options.push(newTag);
      field.value.push(newTag);
    },
    setNone(fieldId) {
      const field = this.fields.find((f) => f.id === fieldId);
      field.value = ["None"];
    },
    cancel() {
      this.$emit("cancel");
    },
    submitAdditionalInfo() {
      const formData = {
        ...this.fields.reduce((acc, field) => {
          acc[field.id] = field.value;
          return acc;
        }, {}),
        triageNurseNotes: this.triageNurseNotes,
        preferredDoctor:
          this.preferredDoctor === "dont_specify" ? null : this.preferredDoctor,
      };
      this.$emit("additional-info-submitted", formData);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.multiselect__tags {
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  min-height: 40px;
}
.multiselect__tag {
  background-color: #e5e7eb;
  color: #374151;
}
.multiselect__option--highlight {
  background-color: #2563eb;
  color: white;
}
.multiselect__input {
  min-height: 20px;
}
</style>
